import React from 'react'
import { MapTo } from '@adobe/aem-react-editable-components'
import Hero from '@sial/aem-cms-components/dist/Hero/Hero'
import { useIntl } from 'react-intl'
import { useDiscoPromoTermsQuery } from '@src/queries/DiscoPromoTermsQuery.generated'
import { useRouter } from '@src/routes'
import { useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { Breakpoints } from '@src/utils/useResponsiveSizes'

const HeroAdapter: React.FC<any> = (props) => {
  const intl = useIntl()
  const router = useRouter()
  const promoId = router.query.promoId as string
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up(Breakpoints.MD), {
    defaultMatches: true,
  })

  const { data: promoTermsData } = useDiscoPromoTermsQuery({
    variables: {
      input: {
        uuid: promoId ?? '',
      },
    },
    skip: !promoId,
    fetchPolicy: 'network-only',
  })

  const discount = promoTermsData?.getPromoTerms?.discount
  const DiscoPromoBannerheadline =
    isDesktop && discount
      ? intl.formatMessage(
          {
            id: 'SPEND_AND_SAVE_DISCOUNT',
            defaultMessage: 'Spend & Save {discount}',
          },
          {
            discount: intl.formatNumber(discount / 100, {
              style: 'percent',
              minimumFractionDigits: 0,
            }),
          }
        )
      : ''

  const translations = {
    DiscoPromoBannerheadline,
  }

  return <Hero {...props} translations={translations} />
}

export default MapTo('cms-commons/components/content/herocomponent')(
  HeroAdapter
)
